import { useQuery, UseQueryResult } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import useCurrentUser from '@/hooks/useCurrentUser';

const tryToFetchMyLike = async (myUserId: string, creationID: number) => {
  try {
    await client.get(`/api/creations/${creationID}/likes/by_user_id`, {
      params: { user_id: myUserId },
    });
    return {};
  } catch (e) {
    if (e?.response?.status === 404) {
      return null;
    }
    throw e;
  }
};

export const createQueryKey = (creationID: number, userID: string) =>
  ['creation/liked', creationID, userID] as const;

const useFetchCreationIsLiked = (
  creationID: number | undefined
): UseQueryResult<boolean> => {
  const { user } = useCurrentUser();

  const userID = user?.userID;

  return useQuery({
    queryFn:
      userID && creationID
        ? async () => !!(await tryToFetchMyLike(userID, creationID))
        : undefined,
    queryKey:
      userID && creationID ? createQueryKey(creationID, userID) : undefined,
    enabled: !!(userID && creationID),
  });
};

export default useFetchCreationIsLiked;
